import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the SignPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'sign',
})
export class SignPipe implements PipeTransform {
  transform(input) {
    if (isNaN(input)) {
      return input;
    } else if (input == 0) { // eslint-disable-line
      return '-';
    } else {
      return (input > 0 ? '+' : '-') + Math.abs(input);
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/pipes/sign/sign.ts